<template>
  <div class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto" id="popup-content"
    @click.self="closeModal">
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:px-[24px] md:py-[40px] overflow-auto">
      <div class="flex items-center justify-between">
        <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
          Place New Order
        </p>
        <button class="text-2xl text-[#353535] cursor-pointer outline-none focus:outline-none" type="button"
          @click="closeModal">
          <span class="mdi text-xl mdi-close"></span>
        </button>
      </div>
      <div class="bg-white px-[12px] md:px-[24px] py-[32px] mt-[16px] rounded-[4px]">
        <h2 class="font-bold text-[20px] leading-[20px] text-[#2463EB] w-full">
          Order # {{ orderNumber }}
        </h2>
        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
            Order For
          </h2>
          <span class="font-medium text-[16px] text-[#353535] leadin-[19.36px]">{{ user.parent.name }}</span>
        </div>
        <div class="mt-[40px] w-full">
          <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full mb-[16px]">
            Delivery Address
          </h2>
          <div class="max-w-[600px] w-full">
            <textarea
              class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
              required :class="{ 'is-invalid': $v.order.deliveryAddress.$error }"
              v-model.trim="$v.order.deliveryAddress.$model"></textarea>
            <span class="text-red-500 text-sm mt-1" v-if="
              $v.order.deliveryAddress.$error &&
              !$v.order.deliveryAddress.required
            ">
              Delivery Address is required.
            </span>
            <span class="text-red-500 text-sm mt-1" v-if="
              $v.order.deliveryAddress.$error &&
              !$v.order.deliveryAddress.minLength
            ">
              Delivery Address must have at least
              {{ $v.order.deliveryAddress.$params.minLength.min }} letters.
            </span>
          </div>
        </div>
        <div class="mt-[16px] w-full">
          <div class="flex items-center gap-[10px] max-w-max mt-[16px]" @click="toggleState = !toggleState">
            <button type="button"
              class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
              role="switch" :aria-checked="toggleState" :class="{
                'bg-[#2463eb]': toggleState,
                'bg-[#E4E4E7]': !toggleState,
              }">
              <span aria-hidden="true"
                class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                :class="{
                  'translate-x-5': toggleState,
                  'translate-x-0': !toggleState,
                }"></span>
            </button>
            <span class="cursor-pointer">
              <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                Additional Information
              </span>
            </span>
          </div>
        </div>
        <div v-if="showContact" class="flex flex-col md:flex-row gap-[10px] w-full mt-[16px]">
          <div class="w-full">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Contact Name</label>
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                type="text" placeholder="Enter contact person name"
                :class="{ 'is-invalid': $v.order.contact.name.$error }" v-model.trim="$v.order.contact.name.$model" />
              <span class="text-red-500 text-sm mt-1" v-if="
                $v.order.contact.name.$error &&
                !$v.order.contact.name.minLength
              ">
                Name must have at least
                {{ $v.order.contact.name.$params.minLength.min }}
                letters.
              </span>
            </div>
          </div>
          <div class="w-full">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Contact Phone</label>
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                type="tel" placeholder="Enter phone number"
                :class="{ 'is-invalid': $v.order.contact.phoneNumber.$error }"
                v-model.trim="$v.order.contact.phoneNumber.$model" />
              <span class="text-red-500 text-sm mt-1" v-if="
                $v.order.contact.phoneNumber.$error &&
                !$v.order.contact.phoneNumber.phone
              ">
                Phone number is not valid
              </span>
            </div>
          </div>
          <div class="w-full">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Contact Email</label>
            <div>
              <input
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                type="email" placeholder="Enter Email Address" :class="{ 'is-invalid': $v.order.contact.email.$error }"
                v-model.trim="$v.order.contact.email.$model" />
              <span class="text-red-500 text-sm mt-1" v-if="
                $v.order.contact.email.$error &&
                !$v.order.contact.email.email
              ">
                Email is not valid
              </span>
            </div>
          </div>
        </div>
        <div v-if="showSpecialInstructions">
          <div class="max-w-[600px] w-full mt-[16px]">
            <label class="text=[#353535] font-medium text-[14px] leading-[20px]">Special Instructions</label>
            <div>
              <textarea
                class="bg-transparent border-[#d0d5dd] border-solid border py-[12px] px-[14px] rounded-[8px] w-full outline-none"
                :class="{ 'is-invalid': $v.order.specialInstructions.$error }"
                v-model.trim="$v.order.specialInstructions.$model"></textarea>
              <span class="text-red-500 text-sm mt-1" v-if="
                $v.order.specialInstructions.$error &&
                !$v.order.specialInstructions.minLength
              ">
                Special instructions must be at least
                {{ $v.order.specialInstructions.$params.minLength.min }}
                characters.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white px-[12px] md:px-[24px] py-[32px] mt-[16px] rounded-[4px] w-full">
        <PurchaseOrderDetail :items="addedItems" @onDeleteItem="onDeleteItemHandler" :isBusyModal="isBusyModal"
          :close="closeModal" :isBusy="isBusy" :onProceed="onProceed" :needsQuote="needsQuote" />
      </div>
      <div class="flex justify-end w-full mt-[16px]" v-if="needsQuote && addedItems.length > 0">
        <button :disabled="isBusy" type="button" @click="getQuote"
          class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] outline-none focus:outline-none max-w-max w-full">
          <span v-if="isBusy">Generating Quote...</span>
          <span v-else>Get Quote</span>
        </button>
      </div>
    </div>
    <AddItem :products="manufacturerProducts" :filteredProducts="filteredProducts" @onItemAdded="onItemAddHandler"
      :groupId="groupId" :edit="item" />
  </div>
</template>
<script>
import { required, minLength, helpers, email } from "vuelidate/lib/validators";
import { helper } from "@/helper";
import PurchaseOrderDetail from "./PurchaseOrderDetail.vue";
import AddItem from "./AddItem.vue";

// eslint-disable-next-line no-useless-escape
const phone = helpers.regex("alpha", /^[0]\d{10}$|[\+]?[234]\d{12}$/);
export default {
  props: ["closeModal", "PurchaseOrder"],
  components: {
    PurchaseOrderDetail,
    AddItem,
  },
  data() {
    return {
      isBusy: false,
      isBusyModal: false,
      toggleState: false,
      orderNumber: "",
      showContact: false,
      showSpecialInstructions: false,
      manufacturerProducts: [],
      filteredProducts: [],
      addedItems: [],
      groupId: "",
      item: null,
      quotes: null,
      order: {
        deliveryAddress: "",
        contact: {
          name: "",
          phoneNumber: "",
          email: "",
        },
        specialInstructions: "",
      },
    };
  },
  validations: {
    order: {
      deliveryAddress: {
        required,
        minLength: minLength(3),
      },
      contact: {
        name: {
          minLength: minLength(3),
        },
        phoneNumber: {
          phone,
        },
        email: {
          email,
        },
      },
      specialInstructions: {
        minLength: minLength(5),
      },
    },
  },
  watch: {
    toggleState(newValue) {
      if (newValue) {
        this.showSpecialInstructions = true;
        this.showContact = true;
      } else {
        this.showSpecialInstructions = false;
        this.showContact = false;
      }
    },
  },
  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
    subTotal() {
      let result = 0;
      this.addedItems.forEach((item) => {
        result += (item.price || 0) * item.quantity;
      });
      return this.formatMoney(result);
    },
    needsQuote() {
      return this.addedItems.length > 0 && this.addedItems.some(item => !item.price || item.price === 0);
    },
  },
  mounted() {
    this.initializeOrder();
    this.getManufacturerProducts();
  },
  methods: {
    async getManufacturerProducts() {
      this.isBusy = true;
      try {
        const response = await this.$http.get(
          "/Products/getListNoPagingForManufacturer?active=true" +
          (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
          (this.groupId ? "&groupId=" + this.groupId : "")
        );
        if (response.ok)
          this.manufacturerProducts = this.filteredProducts = response.body;
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.$toast.error("Failed to fetch products. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    async getQuote() {
      if (this.addedItems.length === 0) {
        this.quotes = null;
        return;
      }
      try {
        this.isBusy = true;
        const payload = {
          orderNumber: this.orderNumber,
          deliveryAddress: this.order.deliveryAddress,
          details: this.addedItems.map(item => ({
            productCode: item.productCode,
            productTax: 0,
            quantity: item.quantity,
            id: item.id,
            price: 0,
            description: item.description,
          })),
          orderContact: this.order.contact,
          status: "draft",
          specialInstructions: this.order.specialInstructions,
          discountAmount: 0,
          customerTax: this.user.parent && this.user.parent.sapTaxClassification ? this.user.parent.sapTaxClassification : this.user.parent.sapTaxClassification,
          distributorCode: this.user.parent && this.user.parent.code ? this.user.parent.code : this.user.parent.code,
        };
        const response = await this.$http.post("/PurchaseOrders/getSapSalesQuote", payload);
        if (response.ok) {
          this.quotes = response.body;
          this.addedItems = this.addedItems.map(item => {
            const quotePrice = this.quotes && this.quotes.productPrices
              ? this.quotes.productPrices.find(p => p.productCode === item.productCode)
              : null;
            return {
              ...item,
              price: quotePrice ? quotePrice.amountPerQuantity : 0,
            };
          });
          if (!this.quotes || !this.quotes.productPrices || this.quotes.productPrices.length === 0) return
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.quotes = null;
        this.addedItems = this.addedItems.map(item => ({ ...item, price: 0 }));
        this.$toast.error("Failed to fetch prices. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    onItemAddHandler(newItem) {
      const product = this.manufacturerProducts.find(
        (product) => product.id === newItem.productId
      );
      this.filteredProducts = this.filteredProducts.filter(
        (product) => product.id !== newItem.productId
      );
      this.prepareItem(product, newItem);
      this.quotes = null;
      this.addedItems = this.addedItems.map(item => ({ ...item, price: 0 }));
    },
    prepareItem(product, newItem) {
      const preparedItem = {
        quantity: newItem.quantity,
        description: newItem.name,
        price: newItem.price,
        id: product.id,
        productCode: product.code,
        productCategory: product.category ? product.category.name : "",
      };
      this.addedItems.push(preparedItem);
      // eslint-disable-next-line no-undef
      $("#mod-item-add").modal("hide");
    },
    onDeleteItemHandler(id) {
      const product = this.manufacturerProducts.find(
        (product) => product.id === id
      );
      this.addedItems = this.addedItems.filter((item) => item.id !== id);
      this.filteredProducts.push(product);
      this.quotes = null;
      this.addedItems = this.addedItems.map(item => ({ ...item, price: 0 }));
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    async initializeOrder() {
      this.isBusy = true;
      try {
        const response = await this.$http.get("/PurchaseOrders/initialize");
        if (response.ok) {
          this.orderNumber = response.body.orderNumber;
          this.groupId = response.body.groupId;
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        this.$toast.error("Failed to initialize order. Please try again.", {
          icon: true,
          rtl: false,
        });
      }
    },
    showValidationError(fieldPath) {
      if (!this.$v.$dirty) return false;
      const field = fieldPath
        .split(".")
        .reduce((obj, path) => obj[path], this.$v);
      return field.$error;
    },
    async onProceed(status) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.addedItems.length === 0) {
        this.$toast.error("Order is empty. Please add items.", {
          icon: false,
          rtl: false,
        });
        return;
      }
      if (this.needsQuote) {
        this.$toast.error("No valid prices available. Please fetch prices.", {
          icon: false,
          rtl: false,
        });
        return;
      }
      try {
        this.isBusyModal = true;
        const data = {
          orderNumber: this.orderNumber,
          deliveryAddress: this.order.deliveryAddress,
          details: this.addedItems,
          orderContact: {
            name: this.order.contact.name,
            phoneNumber: this.order.contact.phoneNumber,
            email: this.order.contact.email,
          },
          status,
          specialInstructions: this.order.specialInstructions,
          discountAmount: 0,
          sapQuoteNumber: this.quotes.quoteNumber,
        };
        const response = await this.$http.post("/PurchaseOrders/create", data);
        if (response.status === 201 && response.ok) {
          this.$toast.success(status === "draft" ? "Order saved to draft!" : "Order successfully generated!", {
            icon: true,
            rtl: false,
          });
          this.closeModal();
        }
      } catch (error) {
        this.$toast.error("Failed to save order. Please try again.", {
          icon: true,
          rtl: false,
        });
      } finally {
        this.isBusyModal = false;
      }
    },
  },
};
</script>